import { Box, Button } from '@material-ui/core';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { RichTextWithEmbeds } from 'components/RichText';
import { hasContent } from 'utils/hasContent';

import { Typography } from '../Typography';
import { useStyles } from './styles';
export interface CompletedContentProps {
  headingText?: React.ReactNode;
  bodyText?: React.ReactNode;
  customMessage?: string;
  handleClick?: () => void;
}

export const CompletedContent: React.VFC<CompletedContentProps> = ({
  headingText,
  bodyText,
  handleClick,
  customMessage,
}) => {
  const styles = useStyles();

  const displayText = () => {
    if (headingText && bodyText) {
      return (
        <>
          <Typography variant="headingMD">{headingText}</Typography>
          <Typography>{bodyText}</Typography>
        </>
      );
    }
    if (customMessage && hasContent(customMessage)) {
      return (
        <div className={styles.customMessage}>
          <RichTextWithEmbeds text={customMessage} />
        </div>
      );
    }
    return (
      <>
        <Typography variant="headingMD">
          <FormattedMessage
            defaultMessage="You’re all set!"
            description="Heading text indicating to user that they completed their task"
          />
        </Typography>
        <Typography>
          <FormattedMessage
            defaultMessage="Great job completing that step! We are reviewing your information and will be in touch soon."
            description="Text to inform user that their information has been submitted"
          />
        </Typography>
      </>
    );
  };

  const showButton = () => {
    return hasContent(customMessage) && handleClick;
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      paddingTop={4}
      gridGap={32}
      className={customMessage && styles.customContentContainer}
    >
      {displayText()}
      {showButton() && (
        <Button
          type="submit"
          variant="contained"
          color="primary"
          onClick={handleClick}
          className={styles.button}
        >
          <FormattedMessage
            defaultMessage="Continue"
            description="Continue button label for the application form"
          />
        </Button>
      )}
    </Box>
  );
};
